import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_ATTACHMENTYPES, res.data)
  })
)

export const show = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_ATTACHMENTYPE, res.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.saveItem(obj).then(res => {
    commit(types.SET_ATTACHMENTYPE, res.data)
    return res
  })
}

export const deleteAttachmentType = async ({ commit }, obj) => {
  await services.deleteAttachmentType(obj).then(res => {
    return res
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}
